import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import { getImageByWidth } from '../../utils/api';
import { Link } from 'react-router-dom';
import Thumbnail from '../Thumbnail';


const MediaGrid = ({ baseUrl, media }) => {
  let xlColWidth = 4;
  if (media.length === 2) {
    xlColWidth = 6;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {media.map((media, idx) => {
          const linkHref = urlJoin(baseUrl, `${idx + 1}`);
          const thumbnailImage = getImageByWidth(media.previewImages.posterFrame, 600);
          return (
            <div key={media.uid} className={`col-sm-6 col-xl-${xlColWidth} mb-4`}>
              <div className="mb-1">
                <Link to={linkHref}>
                  <Thumbnail image={thumbnailImage ? thumbnailImage.url : null} vimeoUrl={media.metadata.sourceUrl} />
                </Link>
              </div>
              <h6 className="heading-display mb-1">
                <Link to={linkHref}>{media.name}</Link>
              </h6>
              <div className="caption" dangerouslySetInnerHTML={{ __html: media.shortDescription }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

MediaGrid.propTypes = {
  baseUrl: PropTypes.string,
  media: PropTypes.arrayOf(PropTypes.object),
};

export default MediaGrid;



// WEBPACK FOOTER //
// ./src/components/TopicTree/MediaGrid.js